import type { RfqViewState } from "./rfq-view-types";
import type { Rfq } from "../../domain/rfq-types";
import { can } from "../../../../shared/auth/access";

type Props = Pick<RfqViewState,
  "user" |
  "rfq" |
  "rfqCommandBusy" |
  "saveSelection" |
  "command"
> & { rfq: Rfq };
export function RfqActions({
  user,
  rfq,
  rfqCommandBusy,
  saveSelection,
  command,
}: Props) {
  return (
    <div className="inline-form-actions rfq-actions">
      {can(user, "rfq.manage") && rfq.status === "DRAFT" ? (
        <button className="secondary-button" disabled={rfqCommandBusy} onClick={saveSelection}>
          Seçimi kaydet
        </button>
      ) : null}
      {can(user, "rfq.publish") &&
      ["SOLE_SOURCE", "EMERGENCY"].includes(rfq.method) &&
      rfq.status === "DRAFT" ? (
        <button
          className="secondary-button"
          disabled={rfqCommandBusy}
          onClick={() => command("method-decision")}
        >
          Yöntem kararını kaydet
        </button>
      ) : null}
      {can(user, "rfq.publish") && rfq.status === "DRAFT" ? (
        <button
          className="approve-button"
          disabled={rfqCommandBusy}
          onClick={() => command("publish")}
        >
          Yayımla
        </button>
      ) : null}
      {can(user, "rfq.publish") && rfq.status === "PUBLISHED" ? (
        <button
          className="secondary-button"
          disabled={rfqCommandBusy}
          onClick={() => command("await-bids")}
        >
          Teklif beklemeye geç
        </button>
      ) : null}
      {can(user, "rfq.publish") &&
      ["PUBLISHED", "AWAITING_BIDS"].includes(rfq.status) ? (
        <button
          className="secondary-button"
          disabled={rfqCommandBusy}
          onClick={() => command("close")}
        >
          Kapat
        </button>
      ) : null}
      {can(user, "rfq.publish") &&
      !["CLOSED", "CANCELLED", "UNSEALED"].includes(rfq.status) ? (
        <button
          className="secondary-button"
          disabled={rfqCommandBusy}
          onClick={() => command("cancel")}
        >
          İptal et
        </button>
      ) : null}
    </div>
  );
}
